// imove-behavior: 上报访问信息

export default async function(ctx) {
  const { pathname = '' } = ctx.payload;
  console.log('RouterBefore needAuthPath, path', window?.location?.pathname, pathname);
  window.nextAegis?.infoAll(`RouterBefore needAuthPath, path=${pathname}`);
}